import { hexToRgb } from '@mui/material';
import { kebabCase } from 'lodash-es';

const chartColors = {};

export function hasChartColors(layerId) {
  return Boolean(chartColors[layerId]);
}

export function setChartColors(layer) {
  const { legend, id } = layer;
  chartColors[id] = legend ? { colors: mapLayerColors(legend), legend } : {};
}

export function getChartColors(layerId) {
  return chartColors[kebabCase(layerId)]?.colors || {};
}

export function getLayerLegend(layerId) {
  return chartColors[layerId]?.legend;
}

function mapLayerColors(legend) {
  return Object.entries(legend).reduce((colors, [bucket, { color, rgb }]) => {
    if (!color && !rgb) return colors;
    const rgbValue = rgb ? [...rgb, 255] : parseLegendColor(color);
    colors[Number(bucket)] = rgbValue;
    return colors;
  }, {});
}

function parseLegendColor(color) {
  if (color === 'transparent') return [0, 0, 0, 0];
  const rgbString = color.includes('#') ? hexToRgb(color) : color;
  const rgbValues = rgbString
    .match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/)
    ?.slice(1);
  return [...rgbValues.map((value) => parseInt(value, 10)), 255];
}
